<template>
  <div class="sd" @click="tohouseDetail()">

   <div class="inphone1" v-if="pcshow">
      <img src="../assets/images/computer.svg" alt="" class="inphone2" >
      <span style="color:#fff;margin-top: 45px;">请用电脑浏览www.zhiyefangdong.com,<br/>可以更好体验哟</span>
   </div>

   <div class="loginmg">
    <div class="containerNa">
      <div class="imglg">
        <img src="../assets/images/zhiyelogoendeee.svg" alt="" class="imglogo" >
      </div>
      
    </div>
  </div>



    <div class="index-2">
      <div class="index-1">
        <el-row type="flex" class="row-bg" style="margin-top:243px;">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <!-- <div class="index-3">
                <span>10年以上地产经验资深团队专为11111
                  <br>职业房东和房地产经纪人倾情打造
                </span>
              </div> -->
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light index-4">职业房东</div>
          </el-col>
        </el-row>

       

      </div>
    </div>
    <el-row type="flex" class="row-bg">
      <el-col :span="24">
        <div class="index-5">
          <img src="../assets/images/relax.png" class="index-6copy" alt="">
          <span class="index-7">最新房源</span>
        </div>
      </el-col>
    </el-row>
    <section class="section">
      <div class="container">
        <div class="row lightcasestudies" style="margin-top:25px;">
          <div class="col-md-4" v-for="todo in houseData" style="cursor: pointer;">
            <div class="case-box" >
              <img
                :src="todo.imgurl"
                alt=""
                style="height: 237px;width: 100%;object-fit: cover;"
                class="img-responsive"
              >
              <div class="case-info clearfix">
                <div class="index-16">
                  <h4 class="index-17">{{todo.village_name}}{{todo.building_no}}号{{todo.room_no}}室</h4>
                  <h5 style="text-align: left;">{{todo.room}} 室 {{todo.hall}} 厅 {{todo.bathrooms}} 卫</h5>
                  <div class="index-18">
                    <h5 style="text-align: left;">
                      <span style="color:red;">{{todo.commission}}</span>%佣金
                    </h5>
                    <h5 class="index-10">
                      <span class="index-11">¥</span>
                      <span class="index-11">{{todo.rental}}</span>
                    </h5>
                  </div>
                </div>
                <!-- <div class="pull-right">
                 
                  <h5 class="index-10"><span class="index-11">¥</span><span class="index-11">{{todo.rental}}</span></h5>
                 
                </div>-->
              </div>
              <!-- end case-info -->
            </div>
            <!-- end case-box -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
        <div class="row">
          <div class="col-md-12 index-14">
            <span class="index-13">查看更多</span>
          </div>
        </div>
      </div>
      <!-- end container -->
    </section>
    <!-- end section -->
    <el-row type="flex" class="row-bg">
      <el-col :span="24">
        <div class="index-5">
          <img src="../assets/images/fdjicon.svg" class="index-6" alt="">
          <span class="index-7">区域找房</span>
        </div>
      </el-col>
    </el-row>
    <!-- END: slider  -->
    <section class="probootstrap-section">
      <div class="container" style="padding-bottom: 84px;">
        <div class="row" style="margin-top:63px;">
          <div
            class="col-lg-3 col-md-4 col-sm-6 col-xs-12 probootstrap-animate"
            data-animate-effect="fadeIn"
            v-for="todod in quyuData"
            style="cursor: pointer;"
          >
            <div class="image-popup" >
              <img
                src="../assets/images/shanghaione.jpg"
                class="img-responsive img-rounded"
                alt="Free Bootstrap Template by uicookies.com"
              >
              <span class="index-15">{{todod.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import https from "../http.js";
export default {
  data() {
    return {
      houseData: [],
      quyuData: [],
      today_views:"",
      pcshow:false
    };
  },

  created: function() {
    this.keepAlive = false;

    https
      .fetchGet("/index/index")
      .then(data => {
        //this.tableData.push(data.data.houseList.data)

        this.houseData = data.data.today_house;
        this.quyuData = data.data.area;
        this.today_views = data.data.today_views;

        //console.log();
      })
      .catch(err => {
        console.log(err);
      });
  },

  methods: {
    tohouseDetail() {
      if(this.pcshow==true){
        this.pcshow=false;
      }else{
        this.pcshow=true;
      }
   
      //this.$router.push({ path: "/test" });
      //alert(id)
      
    },

    toquyusearch(areaid) {
      this.$router.push({ path: "/HouseList", query: { areaid: areaid } });
    },

    tohouselist(){
      this.$router.push({ path: "/HouseList"});
    }
  }
};
</script> 
<style src="../assets/css/bootstrap.min.css" scoped></style>

<style scoped>
.sd {
  background-color: #f2f3f5;
}

.loginmg {
    
    display: flex;
}

.inphone1{
 width: 100%;
    height: 100%;
    background: #000;
    position: fixed;
    z-index: 999;
    opacity: 0.7;
    display: flex;
    flex-direction: column;
}
.inphone2{
  width: 138px;
    height: 144px;
    margin-top: 137px;
    margin-left: 118px;
}

.imglg {
  
}

.imglogo {
        width: 123px;
    height: 97px;
    float: left;
    margin-top: -20px;
    margin-left: 10px;
    cursor: pointer;
}

.containerNa {
  width: 100%;
  height: 60px;
  /* background: linear-gradient(to right, #ffe259, #ffa751); */
  /* background: linear-gradient(to right, #f7ae58, #ffa751); */
  /* background: linear-gradient(to right, #97c74e, #2ab9a5); */
  background: #000;
 
  z-index: 999;
  opacity: 1.0;
}


.index-1 {
  background: url(../assets/images/indexbacone.jpg) no-repeat center center;
  height: 428px;
  width: 100%;
}

.index-fan{
text-align: right;
    margin-right: 93px;
    margin-top: 87px;
}

.index-fan1{
      background: #000;
    color: #fff;
    padding: 8px;
}

.index-2 {
  display: flex;
}
.index-3 {
  width: 126px;
  height: 294px;
  margin: -45px 113px;
  background: rgba(0, 0, 0, 1);
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;
  color: #fff;
  padding-right: 40px;
  font-size: 17px;
}
.index-4 {
  color: #fff;
  font-size: 4em;
  margin-top: -142px;
}
.index-5 {
  margin-top: 70px;
}
.index-6 {
  width: 88px;
  padding: 5px 25px;
  display: inline-block;
  margin: -23px;
}

.index-6copy {
  width: 104px;
  padding: 5px 25px;
  display: inline-block;
  margin: -23px;
}
.index-7 {
  border-left: 4px solid #000;
  padding: 8px 15px;
  display: inline-block;
  margin: 10px;
  font-size: 1.8em;
}
.index-8 {
  display: flex;
  flex-direction: row;
}

.index-10 {
  text-align: left;
}

.index-11 {
  font-size: 20px;
  color: rgb(15, 124, 226);
}

.index-13 {
  background: #000;
  padding: 12px 20px;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.index-14 {
  margin-top: 35px;
  margin-bottom: 40px;
}

.index-15 {
  margin-top: -117px;
  position: absolute;
  margin-left: -22px;
  color: #fff;
  font-size: 27px;
}

/* 今日房源 */
.case-box:hover .magnifier {
  opacity: 0.8;
  filter: alpha(opacity=80);
  /* For IE8 and earlier */
  left: 0;
}

.case-box h4 {
  color: #ffffff;
  padding: 16px 0 0;
  margin: 0;
}

.case-link {
  width: 40px;
  display: block;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  border-radius: 4px;
  height: 40px;
  line-height: 39px;
  margin: 17px 0 0;
  position: absolute;
  right: 5px;
}

.case-box:hover .case-link {
  border-color: #fff;
}

.case-box:hover .case-link a {
  color: #ffffff !important;
}

.case-box small {
  font-style: italic;
  color: rgba(255, 255, 255, 0.8);
}

.lightcasestudies .col-md-4 {
  margin: 15px 0;
}

.lightcasestudies .case-box {
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #ededed;
  position: relative;
  box-shadow: 0px 5px 35px 0px rgba(148, 146, 245, 0.15);
}

.lightcasestudies .case-box h4 {
  color: #232323;
}

.lightcasestudies .case-box small {
  color: #787878;
}

.case-info {
  position: relative;
  padding: 0 10px;
}

.lightcasestudies .case-link {
  background-color: #fff;
  border-color: #eee;
}

.lightcasestudies .case-box:hover {
  border: 1px solid #ededed;
  background: #ffffff !important;
}

/* 今日房源 */

.image-popup {
  margin-bottom: 30px;
  float: left;
  width: 100%;
}

.index-16 {
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
}

.index-17 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 264px;
  text-align: left;
}

.index-18 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
